/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllerResponse__label_string_count_number__Array_ } from '../models/ControllerResponse__label_string_count_number__Array_';
import type { ControllerResponse_AccessUser_Array_ } from '../models/ControllerResponse_AccessUser_Array_';
import type { ControllerResponse_boolean_ } from '../models/ControllerResponse_boolean_';
import type { ControllerResponse_number_Array_ } from '../models/ControllerResponse_number_Array_';
import type { ControllerResponse_Pick_PropertyReportSubscriptionAttributes_id_or_user_id_or_name_or_subject_or_tags__Array_ } from '../models/ControllerResponse_Pick_PropertyReportSubscriptionAttributes_id_or_user_id_or_name_or_subject_or_tags__Array_';
import type { ControllerResponse_PropertyReportSubscriptionAttributes_ } from '../models/ControllerResponse_PropertyReportSubscriptionAttributes_';
import type { ControllerResponse_PropertyReportSubscriptionAttributes_Array_ } from '../models/ControllerResponse_PropertyReportSubscriptionAttributes_Array_';
import type { ControllerResponse_PropertyReportSubscriptionAttributes_or_null_ } from '../models/ControllerResponse_PropertyReportSubscriptionAttributes_or_null_';
import type { CreatePropertyReportSubscriptionAttributes } from '../models/CreatePropertyReportSubscriptionAttributes';
import type { PropertyReportSubscriptionAttributes } from '../models/PropertyReportSubscriptionAttributes';
import type { Record_string_string_or_number_or_boolean_ } from '../models/Record_string_string_or_number_or_boolean_';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PropertyReportService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List property report subscriptions that belong to the current user, or all reports for the organization.
     * @param admin Set this to true to get all reports that belong to the organization, and not just the ones for the current user
     * @returns ControllerResponse_PropertyReportSubscriptionAttributes_Array_ Ok
     * @throws ApiError
     */
    public list(
        admin?: boolean,
    ): CancelablePromise<ControllerResponse_PropertyReportSubscriptionAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/property_report/list',
            query: {
                'admin': admin,
            },
        });
    }
    /**
     * Fetch multiple reports by IDs in a single call (used by bulk-assign mini table)
     * Example: /property_report/by_ids?ids=1,2,3
     * @param ids A comma-separated list of report IDs to fetch
     * @returns ControllerResponse_PropertyReportSubscriptionAttributes_Array_ Ok
     * @throws ApiError
     */
    public byIds(
        ids: string,
    ): CancelablePromise<ControllerResponse_PropertyReportSubscriptionAttributes_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/property_report/by_ids',
            query: {
                'ids': ids,
            },
        });
    }
    /**
     * Search property reports in the organization, limited results for autocomplete.
     * @param q The search query string
     * @param limit The maximum number of results to return
     * @returns ControllerResponse_Pick_PropertyReportSubscriptionAttributes_id_or_user_id_or_name_or_subject_or_tags__Array_ Ok
     * @throws ApiError
     */
    public search(
        q?: string,
        limit?: number,
    ): CancelablePromise<ControllerResponse_Pick_PropertyReportSubscriptionAttributes_id_or_user_id_or_name_or_subject_or_tags__Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/property_report/search',
            query: {
                'q': q,
                'limit': limit,
            },
        });
    }
    /**
     * Search report tags in the organization with counts (for autocomplete badges).
     * @param q The search query string
     * @param limit The maximum number of results to return
     * @returns ControllerResponse__label_string_count_number__Array_ Ok
     * @throws ApiError
     */
    public searchTags(
        q?: string,
        limit?: number,
    ): CancelablePromise<ControllerResponse__label_string_count_number__Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/property_report/search_tags',
            query: {
                'q': q,
                'limit': limit,
            },
        });
    }
    /**
     * Get all report IDs in the organization that have the provided tag.
     * @param tag The tag name to filter reports by
     * @returns ControllerResponse_number_Array_ Ok
     * @throws ApiError
     */
    public reportsByTag(
        tag: string,
    ): CancelablePromise<ControllerResponse_number_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/property_report/reports_by_tag',
            query: {
                'tag': tag,
            },
        });
    }
    /**
     * Update the metadata of a property report.
     * @param reportId The ID of the property report to update
     * @param requestBody The metadata to update. Must be a flat object with string, number or boolean values.
     * @returns ControllerResponse_boolean_ Ok
     * @throws ApiError
     */
    public updateMetadata(
        reportId: number,
        requestBody: Record_string_string_or_number_or_boolean_,
    ): CancelablePromise<ControllerResponse_boolean_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/property_report/{reportID}/metadata',
            path: {
                'reportID': reportId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Create a new property report subscription.
     * @param requestBody The attributes of the property report subscription to create
     * @returns ControllerResponse_PropertyReportSubscriptionAttributes_or_null_ Ok
     * @throws ApiError
     */
    public create(
        requestBody: CreatePropertyReportSubscriptionAttributes,
    ): CancelablePromise<ControllerResponse_PropertyReportSubscriptionAttributes_or_null_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/property_report',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Response for unauthorized access`,
            },
        });
    }
    /**
     * Get a property report by ID or public ID. Only one of id or public_id should be provided.
     * @param id The ID of the property report to get
     * @param publicId The public ID of the property report to get
     * @param logVisit
     * @returns ControllerResponse_PropertyReportSubscriptionAttributes_ Ok
     * @throws ApiError
     */
    public getReport(
        id?: number,
        publicId?: string,
        logVisit?: boolean,
    ): CancelablePromise<ControllerResponse_PropertyReportSubscriptionAttributes_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/property_report',
            query: {
                'id': id,
                'public_id': publicId,
                'log_visit': logVisit,
            },
        });
    }
    /**
     * Update an existing property report subscription.
     * @param requestBody The updated attributes of the property report subscription
     * @returns ControllerResponse_PropertyReportSubscriptionAttributes_or_null_ Ok
     * @throws ApiError
     */
    public update(
        requestBody: PropertyReportSubscriptionAttributes,
    ): CancelablePromise<ControllerResponse_PropertyReportSubscriptionAttributes_or_null_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/property_report',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Response for unauthorized access`,
            },
        });
    }
    /**
     * Delete a property report subscription.
     * @param id The ID of the property report subscription to delete
     * @returns ControllerResponse_boolean_ Ok
     * @throws ApiError
     */
    public delete(
        id: number,
    ): CancelablePromise<ControllerResponse_boolean_> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/property_report',
            query: {
                'id': id,
            },
            errors: {
                403: `Response for unauthorized access`,
            },
        });
    }
    /**
     * Get the list of users who have access to the specified property report.
     * @param reportId The ID of the property report
     * @returns ControllerResponse_AccessUser_Array_ Ok
     * @throws ApiError
     */
    public getAccess(
        reportId: number,
    ): CancelablePromise<ControllerResponse_AccessUser_Array_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/property_report/{reportID}/access',
            path: {
                'reportID': reportId,
            },
        });
    }
    /**
     * Grant access to a property report for a list of users.
     * @param reportId The ID of the property report
     * @param notify Whether to notify the users about the granted access via email
     * @param requestBody A list of objects containing user information and access level
     * @returns ControllerResponse_AccessUser_Array_ Ok
     * @throws ApiError
     */
    public createAccess(
        reportId: number,
        notify: boolean,
        requestBody: Array<{
            read_only?: boolean;
            email: string;
            user_id: string | null;
        }>,
    ): CancelablePromise<ControllerResponse_AccessUser_Array_> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/property_report/{reportID}/access',
            path: {
                'reportID': reportId,
            },
            query: {
                'notify': notify,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Revoke access to a property report for a user.
     * @param reportId The ID of the property report
     * @param id The ID of the user whose access is being revoked
     * @returns ControllerResponse_boolean_ Ok
     * @throws ApiError
     */
    public deleteAccess(
        reportId: number,
        id: string,
    ): CancelablePromise<ControllerResponse_boolean_> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/property_report/{reportID}/access',
            path: {
                'reportID': reportId,
            },
            query: {
                'id': id,
            },
        });
    }
    /**
     * Update the access level of a user for a property report.
     * @param reportId The ID of the property report
     * @param userId The ID of the user whose access is being updated
     * @param requestBody An object containing the new access level
     * @returns ControllerResponse_boolean_ Ok
     * @throws ApiError
     */
    public updateAccess(
        reportId: number,
        userId: string,
        requestBody: {
            read_only: boolean;
        },
    ): CancelablePromise<ControllerResponse_boolean_> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/property_report/{reportID}/access/{userID}',
            path: {
                'reportID': reportId,
                'userID': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                403: `Response for unauthorized access`,
            },
        });
    }
    /**
     * Send an email with the property report.
     * @param id The ID of the property report to send via email
     * @returns ControllerResponse_boolean_ Ok
     * @throws ApiError
     */
    public sendEmail(
        id: number,
    ): CancelablePromise<ControllerResponse_boolean_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/property_report/send_email',
            query: {
                'id': id,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any Accepted
     * @throws ApiError
     */
    public generatePdfTask(
        requestBody: any,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/property_report/generate_pdf_task',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
